import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export const EventEngagementIcon = (props: SvgIconProps): ReactElement => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
    >
      <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM6 12.575L10 8.575L14 12.575L18 8.575L19 9.575V5H5V11.575L6 12.575ZM5 19H19V12.4L18 11.4L14 15.4L10 11.4L6 15.4L5 14.4V19ZM5 19V12.4V14.4V5V19Z" />
    </SvgIcon>
  );
};
